import { MijnRoute } from '../../mijn-navigatie.model';

export const MORTGAGE_BUILD_FUND_DECLARE: MijnRoute = {
    path: 'bouwdepot/declaratie',
    navigationEvent: 'toBouwdepotDeclaratie',
    regex: /^\/hypotheek\/bouwdepot\/declaratie$/,
    webcomponent: 'mijn-hypotheken-bouwdepot-webcomponent',
    internalPath: 'declaratie'
};
